/* eslint react/prop-types: 0 */
import React, { useState } from "react";
import FsLightbox from "fslightbox-react";

import { prepareImageURL } from "../helpers/helper";

// eslint-disable-next-line react/prop-types
const ImageModal = ({ images, themeStyles, watermark }) => {
  // if toggler is updated when lightbox is closed it will open it
  // if toggler is updated when lightbox is opened it will close it
  const [toggler, setToggler] = useState(false);
  const [slide, setSlide] = useState(0);

  const handleImageOnClick = (toggler, slide) => {
    setToggler(!toggler);
    setSlide(slide);
  };

  const sources = images.map((image) =>
    watermark ? image.watermark_url : image.image_url
  );

  return (
    <div className={`${themeStyles.mediaRow}`}>
      <FsLightbox
        type="image"
        toggler={toggler}
        slide={slide}
        sources={sources}
      />
      {images.map((image, i) => {
        return (
          <div className={themeStyles.colm} key={i}>
            <div
              className={`${themeStyles.mediaBox}`}
              onClick={() => handleImageOnClick(toggler, i + 1)}
            >
              <img src={prepareImageURL(image, 480, 320, false)} alt="" />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ImageModal;
